import React, { useState, useRef, useEffect } from 'react';
// import { Icon } from '@alifd/next';
import DetailIcon from '@/common/detail-icon';
import { resetUrl, getUrl } from '../../../../common/reset-image';
import doLog from '../../../../common/log';
import './index.less';

interface PropTypes {
  mediaItems: Partial<DetailTypes.MediaItem>[];
  activeId: number;
  setActiveId: (i: number) => void;
}
// 展示List图片的个数
const SHOW_ITEMS_NUMBER = 5;
// 展示List图片+margin-bottom的高度
const ITEMS_HEIGHT = 76;

export default function ImageList(props: PropTypes) {
  const { setActiveId, activeId, mediaItems } = props;

  //滑动距离
  const [swipeDistance, setSwipeDistance] = useState(0);
  //商品图片列表的长度，也是图片的个数
  const ImageListLength = mediaItems.length;
  //showFirstItemRef指向展示列表中第一个品在商品列表中的index
  const showFirstItemRef = useRef(0);
  //showLastItemRef指向展示列表中最后一个品在商品列表中的index，当图片列表长度大于7时初始值为6,图片列表长度小于7时初始值为列表长度-1
  let showLastItemRef = useRef(0);
  if (ImageListLength <= SHOW_ITEMS_NUMBER) {
    showLastItemRef = useRef(ImageListLength - 1);
  } else {
    showLastItemRef = useRef(SHOW_ITEMS_NUMBER - 1);
  }

  //图片渲染逻辑
  const renderImage = (url: string, index: number) => {
    return (
      <div
        className={`main-item${activeId === index ? ' actived' : ''}`}
        key={index}
        onMouseEnter={(e) => {
          //阻止元素默认行为
          e.preventDefault();
          doLog(`/sc.details.main_image_list_${index}`);
          setActiveId(index);
        }}
      >
        <img className="image-list-item" loading="lazy" src={url} />
        <div className="image-list-item-mask"></div>
      </div>
    );
  };
  //点击上滑按钮，改变展示列表上下指针和滑动距离，如果activeId小于当前first指针，则将activeId当前值传进来
  const clickPrevArrow = (index?: number) => {
    if (showFirstItemRef.current > SHOW_ITEMS_NUMBER) {
      showFirstItemRef.current -= SHOW_ITEMS_NUMBER;
      showLastItemRef.current -= SHOW_ITEMS_NUMBER;
      setSwipeDistance(swipeDistance + SHOW_ITEMS_NUMBER * ITEMS_HEIGHT);
    } else {
      showFirstItemRef.current = 0;
      showLastItemRef.current = 0 + SHOW_ITEMS_NUMBER - 1;
      setSwipeDistance(0);
    }
    if (activeId < showFirstItemRef.current) {
      clickPrevArrow(activeId);
    }
    setActiveId(index || showFirstItemRef.current);
  };
  //点击下滑按钮，改变展示列表上下指针和滑动距离
  const clickNextArrow = (index?: number) => {
    if (ImageListLength - showLastItemRef.current > SHOW_ITEMS_NUMBER) {
      showFirstItemRef.current += SHOW_ITEMS_NUMBER;
      showLastItemRef.current += SHOW_ITEMS_NUMBER;
      setSwipeDistance(swipeDistance - SHOW_ITEMS_NUMBER * ITEMS_HEIGHT);
    } else {
      showFirstItemRef.current = ImageListLength - SHOW_ITEMS_NUMBER;
      showLastItemRef.current = ImageListLength - 1;
      setSwipeDistance(SHOW_ITEMS_NUMBER * ITEMS_HEIGHT - ImageListLength * ITEMS_HEIGHT);
    }
    if (activeId > showLastItemRef.current) {
      clickNextArrow(activeId);
    }
    setActiveId(index || showFirstItemRef.current);
  };

  const CustomPrevArrow = () => {
    return (
      <div className={`top-container ${showFirstItemRef.current == 0 ? 'disabled' : ''}`}>
        <div className="top-mask"></div>
        <div
          className={`arrow-link arrow-link-top `}
          onClick={(e) => {
            e.preventDefault();
            clickPrevArrow();
          }}
        >
          <DetailIcon symbol={'icon-up'} className={'detail-symbol'} />
        </div>
      </div>
    );
  };

  const CustomNextArrow = () => {
    return (
      <div
        className={`bottom-container ${
          showLastItemRef.current == ImageListLength - 1 ? 'disabled' : ''
        }`}
      >
        <div className="bottom-mask"></div>
        <div
          className={`arrow-link arrow-link-bottom `}
          onClick={(e) => {
            e.preventDefault();
            clickNextArrow();
          }}
        >
          <DetailIcon symbol={'icon-down'} className={'detail-symbol'} />
        </div>
      </div>
    );
  };

  return (
    <div className="detail-quick-image-list">
      <CustomPrevArrow />
      <div className="image-list-slider" style={{ transform: `translateY(${swipeDistance}px)` }}>
        {mediaItems &&
          mediaItems.map((item, index) =>
            // @ts-ignore
            renderImage(resetUrl(getUrl(item), '140'), index, item?.type),
          )}
      </div>
      <CustomNextArrow />
    </div>
  );
}
